class PathrohiCarouselProgress extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    const carousel = this.parentElement?.querySelector(':scope > slideshow-component');
    const scroller = carousel?.querySelector(':scope > slideshow-container > slideshow-slides');
    const slides = Array.from(scroller?.querySelectorAll(':scope > slideshow-slide') || []);
    const bar = this.querySelector('[data-pathrohi-carousel-progress-bar]');
    const status = this.querySelector('[data-pathrohi-carousel-progress-status]');

    if (!(scroller instanceof HTMLElement) || !(bar instanceof HTMLElement) || slides.length < 2) {
      this.hidden = true;
      return;
    }

    let animationFrame = 0;
    let announcedItem = 0;

    const update = () => {
      animationFrame = 0;
      const scrollPosition = Math.abs(scroller.scrollLeft);
      let currentIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - scrollPosition);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          currentIndex = index;
        }
      });

      const currentItem = currentIndex + 1;
      const progress = `${(currentItem / slides.length) * 100}%`;
      this.style.setProperty('--pathrohi-carousel-progress', progress);
      this.setAttribute('aria-valuemax', String(slides.length));
      if (currentItem !== announcedItem) {
        this.setAttribute('aria-valuenow', String(currentItem));
        this.setAttribute('aria-valuetext', `Item ${currentItem} of ${slides.length}`);
        if (status) status.textContent = `Item ${currentItem} of ${slides.length}`;
        announcedItem = currentItem;
      }
    };

    const requestUpdate = () => {
      if (animationFrame) cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(update);
    };

    scroller.addEventListener('scroll', requestUpdate, { passive: true });
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(requestUpdate);
      this.resizeObserver.observe(scroller);
    }
    this.dataset.ready = 'true';
    requestUpdate();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('pathrohi-carousel-progress')) {
  customElements.define('pathrohi-carousel-progress', PathrohiCarouselProgress);
}
